@import "../../global/gx-ide-common.scss";
@import "../../global/gx-ide-mixins.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
}

.header {
  display: grid;
  padding: var(--gxg-container--padding);
  gap: var(--spacing-gap-l);
  grid-template-columns: 1fr auto;
  :nth-child(2) {
    align-self: self-end;
  }
  margin-block-end: 16px;
}

// deploy properties
.deploy-properties {
  display: grid;
  grid-auto-rows: max-content;
  grid-template-columns: max-content 1fr max-content;
  align-items: center;
  border-block-start: var(--section-common-border);
  padding-block-start: 16px;
}

.label.target-types {
  grid-column: 1;
}
.target-types-combo {
  grid-column: 2;
}
.target-types-button-checkbox-wrapper {
  grid-column: 3;
}

.label.application-server {
  grid-column: 1;
}
.application-server-combo {
  grid-column: 2;
}

.label.generator {
  grid-column: 1;
}
.generator-combo {
  grid-column: 2;
}

.target-type__description {
  grid-column: 2;
}

.label.display-name {
  grid-column: 1;
}
.display-name-input {
  grid-column: 2;
}

.footer {
  margin-block-start: 16px;
}
